import React from 'react';
import KeyGeneration from './components/KeyGeneration';

const KeyGenerationPage: React.FC = () => {
  // Title is set at the application level
  return <KeyGeneration />;
};

export default KeyGenerationPage;